/**
 * Get data for product/product variation for calling
 * custom Google Analytics 4 events. (DUB-606)
 *
 * @param {number} productId
 * @param {number} productVariationId
 * @returns {Promise<object>} - data for GA4 events
 */
async function fetchGA4ProductData(productId, productVariationId) {
    const url = new URL('/ga4-product-data', window.location.origin)

    url.searchParams.append('product_id', productId)

    if (productVariationId) {
        url.searchParams.append('product_variation_id', productVariationId)
    }

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    })

    const data = await response.json()

    if (!data.status) {
        return null
    }

    return data['data']
}

async function trackGA4ProductDataEvent(eventName, productId, productVariationId) {
    if (!window.GA4Tracking) {
        return
    }

    const data = await fetchGA4ProductData(productId, productVariationId)

    if (!data) {
        return
    }

    window.GA4Tracking.trackCustomEvent(eventName, data)
}

rEvent.on('VariationValue.changed', function (changedVariationValue) {
    if ([4, 37, 3].includes(changedVariationValue.variation_id)) {
        trackGA4ProductDataEvent('videnie_produktu', window.productData.id, window.productData.product_variation_id || null)
    }
})

rEvent.on('Custom.Cart.addedItem', function ({form, response}) {
    const productInput = form.querySelector('[name="id"]')
    const productVariationInput = form.querySelector('[name="product_variation_id"]')

    const productId = productInput ? productInput.value : null
    const productVariationId = productVariationInput ? productVariationInput.value : null

    trackGA4ProductDataEvent('vlozenie_produktu_do_kosika', productId, productVariationId)
})

rEvent.on('Custom.productRatingFormSubmit', function ({form}) {
    const productId = form.querySelector(('[name="product_id"]')).value

    trackGA4ProductDataEvent('hodnotenie_produktu', productId, null)
})

rEvent.on('Custom.articleRatingFormSubmit', function(ratingValue) {
    if (!window.articleInfo) {
        return
    }

    const eventData = {
        nazov_clanku: window.articleInfo.name,
        nazov_kategorie: window.articleInfo.section.name,
        hodnotenie: ratingValue,
    }

    if (!window.GA4Tracking) {
        return
    }

    window.GA4Tracking.trackCustomEvent('hodnotenie_clanku', eventData)
})

/**
 * Track filter change in listing page to Google Analytics 4.
 *
 * @param {string} filterName
 * @param {string} filterValue
 * @param {string} filterKey
 */
function trackGA4ListingFilter(filterName, filterValue, filterKey = 'filtrovanie') {
    if (!window.GA4Tracking) {
        return
    }

    const eventData = {nazov_kategorie: window.categoryInfo.menu_name || window.categoryInfo.name};
    eventData[filterKey] = filterValue;

    window.GA4Tracking.trackCustomEvent(filterName, eventData)
}

document.addEventListener('DOMContentLoaded', function () {
    window.GA4Tracking.trackCustomEvent = function(eventName, data) {
        dataLayer.push({event: eventName, eventData: data});
    }

    // event: elements that should trigger this GA4 event
    const filterInputs = {
        filtrovanie_podla_stylu: document.querySelectorAll('[name="filter[properties][22][]"]'),
        filtrovanie_podla_kolekcie: document.querySelectorAll('[name="filter[tags][]"]'),
        filtrovanie_podla_materialu: document.querySelectorAll('[name="filter[properties][10][]"]'),
        filtrovanie_podla_hrubky: document.querySelectorAll('[name="filter[properties][11][]"]'),
        filtrovanie_podla_motivu: document.querySelectorAll('[name="filter[properties][24][]"]'),
        filtrovanie_podla_typu: document.querySelectorAll('[name="filter[properties][25][]"]'),
        filtrovanie_podla_umiestnenia: document.querySelectorAll('[name="filter[properties][26][]"]'),
        filtrovanie_podla_tvaru: document.querySelectorAll('[name="filter[properties][29][]"]'),
        filtrovanie_vlastny_text: document.querySelectorAll('[name="filter[properties][37][]"]'),
    };

    Object.keys(filterInputs).forEach(function (filterName) {
        if (!filterInputs[filterName].length) {
            return;
        }

        filterInputs[filterName].forEach(function (input) {
            input.addEventListener('change', function () {
                if (!input.checked) {
                    return;
                }

                const label = input.parentNode.querySelector('.sc-value');
                if (!label) {
                    return;
                }

                trackGA4ListingFilter(filterName, label.innerText.trim())
            })
        })
    });

    // sort change event
    const sortSelect = document.querySelector('[name="fake-sort"]');
    if (sortSelect) {
        sortSelect.addEventListener('change', function () {
            const selectedOption = sortSelect.querySelector('option:checked');

            trackGA4ListingFilter('zoradenie', selectedOption.innerText.trim(), 'zoradenie')
        })
    }
});
